export default __webpack_public_path__ + "static/X03-3fd88592a33a7f92e3e460a47bd1438c.png";